import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import GatsbyImage from 'gatsby-image';
import PropTypes from 'prop-types';

import { useKeenSlider } from 'keen-slider/react';
import { SideBySide } from './side-by-side';
import { Circle } from './vectors';

function TextWithSlider({ image, children, reverse, bgColorClass }) {
  function ArrowLeft({ onClick }) {
    return (
      <button
        type="button"
        onClick={onClick}
        className="p-2 text-white transition duration-150 ease-in-out rounded-full pointer-events-auto "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="w-8 h-8 text-white"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
    );
  }

  ArrowLeft.propTypes = {
    onClick: PropTypes.func.isRequired,
  };

  function ArrowRight({ onClick }) {
    return (
      <button
        type="button"
        onClick={onClick}
        className="p-2 text-white transition duration-150 ease-in-out rounded-full pointer-events-auto "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="w-8 h-8 text-white"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    );
  }

  ArrowRight.propTypes = {
    onClick: PropTypes.func.isRequired,
  };

  function Image() {
    const data = useStaticQuery(graphql`
      {
        allGelatoCakesJson {
          nodes {
            id
            image {
              childImageSharp {
                fluid(maxWidth: 500, quality: 90) {
                  ...GatsbyImageSharpFluid_withWebp_tracedSVG
                }
              }
            }
            title
          }
        }
      }
    `);

    const [currentSlide, setCurrentSlide] = React.useState(0);
    const [sliderRef, slider] = useKeenSlider({
      initial: 0,
      loop: true,
      slideChanged(s) {
        setCurrentSlide(s.details().relativeSlide);
      },
      slidesPerView: 1,
    });

    return (
      <div className="relative max-w-lg px-24 mx-auto mt-12 sm:px-4">
        <div className="navigation-wrapper">
          <ul ref={sliderRef} className="flex-1 keen-slider">
            {data.allGelatoCakesJson.nodes.map((cake) => (
              <li key={cake.id} className="p-2 sm:px-24 keen-slider__slide">
                <div className="relative w-full">
                  <div className="absolute inset-0">
                    <Circle />
                  </div>
                  <div className="p-3">
                    <div className="relative h-0 aspect-ratio-square">
                      <div className="absolute inset-0 flex items-center justify-center overflow-hidden rounded-full">
                        <GatsbyImage
                          fluid={cake.image.childImageSharp.fluid}
                          className="w-full h-full"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <h2 className="mt-4 text-sm font-black text-center text-white sm:text-2xl font-dots">
                  {cake.title === 'The Mountain (extra $10)'
                    ? 'The Mountain'
                    : cake.title ===
                      'All Sorts (extra $15 for small/large, extra $20 for medium)'
                    ? 'All Sorts'
                    : cake.title}
                </h2>
              </li>
            ))}
          </ul>
          {slider && (
            <div className="absolute inset-0 flex items-center justify-between w-full mx-auto pointer-events-none">
              <ArrowLeft
                onClick={(e) => e.stopPropagation() || slider.prev()}
              />
              <ArrowRight
                onClick={(e) => e.stopPropagation() || slider.next()}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
  return (
    <SideBySide
      slot1={children}
      slot2={<Image />}
      bgColorClass={bgColorClass}
      reverse={reverse}
    />
  );
}

TextWithSlider.propTypes = {
  children: PropTypes.node.isRequired,
  image: PropTypes.object.isRequired,
  reverse: PropTypes.bool,
  bgColorClass: PropTypes.string,
};

export { TextWithSlider };
